import { render, staticRenderFns } from "./SingleServerCard.vue?vue&type=template&id=1652815f&"
import script from "./SingleServerCard.vue?vue&type=script&lang=js&"
export * from "./SingleServerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports